import styled from 'styled-components';

export const Container = styled.div`
    position: absolute;
    z-index: 90;
    top: ${props => props.top ? props.top : 'auto'};
    left: ${props => props.left ? props.left : 'auto'};
    transform: ${props => props.transform ? props.transform : ''};

    &.posLeft.active{
        left: 35px;
        top: 15px;
    }

    button{
        position: relative;
        width: ${props => props.width ? props.width : '45px'};
        height: ${props => props.height ? props.height : '45px'};
        background-color: ${props => props.bgc ? props.bgc : ''};
    }

    button:hover{
        background-color: ${props => props.bgcHover ? props.bgcHover : ''};
    }

    svg{
        font-size: 2.2rem;
    }

    .textBtn{
        text-transform: none;
        transition: background-color 250ms;
        overflow: hidden;
        white-space: nowrap;
        position: absolute;
        font-size: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0px 8px 0px 6px;
        background-color: ${props => props.bgc ? props.bgc : '#3783e7'};
        border-radius: ${props => props.br ? props.br : ''};
        width: 90px;
        height: 30px;
        box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12);
        z-index: -1;
    }

    button:hover .textBtn{
        background-color: ${props => props.bgcHover ? props.bgcHover : '#275ba0'};
    }

    &.animate .textBtn{
        transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1), width 300ms 40ms, transform 300ms 0ms;
    }

    &.active.animate .textBtn{
        transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1), width 400ms 300ms, transform 400ms 400ms;
    }

    &.active .textBtn{
        transform: translateX(0px) !important;
        width: 30px !important;
    }

    &.dirLeft .textBtn{
        transform: translateX(-100%);
        left: 5px;
    }

    &.dirRight .textBtn{
        transform: translateX(100%);
        right: 5px;
    }

    .textBtn > span{
        transform: translateY(0px);
        position: relative;
        white-space: nowrap;
    }

    &.animate .textBtn > span{
        transition: 250ms 350ms;
    }

    &.active.animate .textBtn > span{
        transition: 250ms 150ms;
    }

    &.active .textBtn > span{
        transform: translateY(-40px);
    }
`;